import { Route, Switch } from 'react-router-dom'

import MajorProfile from '@main/containers/colleges/MajorProfile'
import { MajorComparison } from '@main/containers/colleges/MajorComparison'
import ChoosingMajor from '@main/containers/colleges/ChoosingMajor'
import { MajorSearch } from '@main/containers/colleges/MajorSearch'

import { CipDetail } from './detail'

import { ClusterListing } from '../clusters/listing'

const Majors = () => {
  const routes = [
    {
      path: '/education/list',
      exact: true,
      render(props) {
        return <MajorSearch {...props} />
      }
    },
    {
      path: '/majors/clusters',
      exact: true,
      render(props) {
        return <ClusterListing listMajors={true} {...props} />
      }
    },
    {
      path: '/majors/d/:majorId',
      exact: true,
      render(props) {
        return <MajorProfile {...props} />
      }
    },
    {
      path: '/majors/detail/:cipCode',
      exact: true,
      render(props) {
        return <CipDetail {...props} />
      }
    },
    {
      path: '/majors/comparison',
      exact: true,
      render(props) {
        return <MajorComparison {...props} />
      }
    },
    {
      path: '/majors/choosing',
      exact: true,
      render(props) {
        return <ChoosingMajor {...props} />
      }
    }
  ]

  return (
    <div>
      <Switch>
        {routes.map((route, idx) => (
          <Route
            key={idx}
            {...route}
            render={props => {
              return route.render({ ...props })
            }}
          />
        ))}
      </Switch>
    </div>
  )
}

export { Majors }
